import { createSlice } from '@reduxjs/toolkit';
export interface ICurrency {
  code: string;
  name: string;
  symbol: string;
}

const initalState: {
  timezone: string;
  currency: ICurrency;
} = {
  timezone: '',
  currency: {
    code: '',
    name: '',
    symbol: ''
  }
};

const preferences = createSlice({
  name: 'preferences',
  initialState: initalState,
  reducers: {
    setPreferences: (state, action) => {
      return { ...state, ...action.payload };
    }
  }
});

export const { setPreferences } = preferences.actions;
export default preferences.reducer;
